import { useUnitItemContext } from "@/hooks/useUnitItemContext";
import { useUnitJourneyContext } from "@/hooks/useUnitJourneyContext";
import { FunnelType } from "@/lib/utils";

export const useActivateRentalJourney = () => {
    const { unitGroup } = useUnitItemContext();
    const {
        isOpen,
        setIsOpen,
        setUnitJourneyStep,
        setSelectedUnitId,
        setFunnelType,
    } = useUnitJourneyContext();

    const activateRentalJourney = (unitId: number | string) => {
        if (!isOpen) {
            setIsOpen(true);
        }
        setSelectedUnitId(unitId);

        // Here we need to set the journey to "vbp" if there are multiple subgroups
        if (unitGroup.sub_groups && unitGroup.sub_groups.length > 1) {
            setUnitJourneyStep("vbp");
        } else {
            setUnitJourneyStep("funnel");
        }
        setFunnelType(FunnelType.RENT);
    };

    return activateRentalJourney;
};
